import Vue from 'vue'
import MachineLibrary from './MachineLibrary.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(MachineLibrary)
}).$mount('#machinelibrary')
